export default (parent, selectors, product_json, res) => {
  if (selectors.size) {
    var option2_current_values = Array.from(selectors.size.options).map((option) => option.value);
  }

  var option2_available_values = product_json.variants
    .filter((v) => v.option1 === selectors.color.value)
    .map((variant) => variant.option2);

  // Add Missing Options to select, then remove non-existent options from select
  option2_available_values.forEach((value) => {
    if ((option2_current_values || []).includes(value)) {
      return;
    }
    const optionElement = document.createElement('option');
    optionElement.value = value;
    optionElement.textContent = value;
    selectors.size.appendChild(optionElement);
  });

  (option2_current_values || []).forEach((value) => {
    if (option2_available_values.includes(value)) {
      return;
    }
    const optionElement = selectors.size.querySelector(`option[value="${value}"]`);
    if (optionElement) {
      optionElement.remove();
    }
  });

  // Get Currently Selected Variant and
  const selected_variant = product_json.variants.find(
    (v) => v.option1 === selectors.color.value && v.option2 === selectors.size.value,
  );
  selectors.id.value = selected_variant.id;

  // custom event to update form
  const event = new CustomEvent('variantUpdatedForm', {
    detail: {
      variantId: selected_variant.id,
      parent: parent, // Include the parent if needed for further context
    },
  });
  document.dispatchEvent(event);

  // Button Logic for sold out variants
  let variant_available = selected_variant.available;

  if (res) {
    variant_available = res.color[selected_variant.id] ? res.color[selected_variant.id] : selected_variant.available;
  }

  if (selected_variant) {
    if (variant_available) {
      selectors.addToCart.removeAttribute('disabled');
      selectors.addToCartText.textContent = 'Add to bag +';
    } else {
      selectors.addToCart.setAttribute('disabled', true);
      selectors.addToCartText.textContent = 'Sold Out';
    }
  } else {
    selectors.addToCart.setAttribute('disabled', true);
    selectors.addToCartText.textContent = 'Sold Out';
  }

  // Update Image
  const new_featured_image = selected_variant.featured_image?.src;
  if (new_featured_image) {
    selectors.image.setAttribute('src', new_featured_image);
  }
};
